import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	//相当于data
	state: {
		walletName: '',
		userName: '',
		twoSided: '',
		compose: '',
		dragonTiger: '',
		baccarat: '',
		gallbladder: '',
		userInfo: {}
	},
	//相当于computed
	getters: {

	},
	//相当于methods
	mutations: {
		setUserInfo(state, playload) {
			state.userInfo = playload;
		},
		changeWalletName(state, playload) {
			state.walletName = playload;
		},
		changeUserName(state, playload) {
			state.userName = playload;
		},
		changeTwoSided(state, playload) {
			state.twoSided = playload;
		},
		changeCompose(state, playload) {
			state.compose = playload;
		},
		changeDragonTiger(state, playload) {
			state.dragonTiger = playload;
		},
		changeBaccarat(state, playload) {
			state.baccarat = playload;
		},
		changeGallbladder(state, playload) {
			state.gallbladder = playload;
		},
	},
	//可以同时执行多个mutations方法
	actions: {

	}
})


// WEBPACK FOOTER //
// ./src/store/index.js